<template>
	<div>
    <form @submit.prevent="checkValidation() && submitStage()">
			<div class="row">
				<div class="col-md-6 px-50 py-70 d-none d-md-block pt-48 pr-4">
					<img src="img/CorvidLogo/New/PAYGATE LOGO_CMYK.svg" />
				</div>
				<div class="col-sm-12 col-md-6">


					<div class="form-wrapper">
						<div class="text-center mb-20">
							<img
								class="mx-auto d-xs-block d-sm-block d-md-none d-lg-none d-xl-none"
								style="max-width: 136.76px;margin-bottom:20px;"
								src="img/CorvidLogo/New/PAYGATE LOGO_CMYK_P.svg"
							/>

							<h2 class="mb-20">Login</h2>
						</div>
							<!-- Username/Email -->
							<div
								class="form-group"
								:class="{'warn': $v.form.userName.$error, 'invalid' : this.errorMessage,shake: this.shake }"
							>
								<i class="input-icon fa fa-user"></i>
								<input
									v-model="$v.form.userName.$model"
									id="username"
									data-testid="username"
									type="text"
									class="form-control-lg form-control input"
									placeholder="Username"
									v-focus
								/>

								<!-- Validation Messages -->
								<span v-if="$v.form.userName.$dirty">
									<small
										class="form-text text-warning small"
										v-if="!$v.form.userName.required"
									>A username is required</small>
								</span>
							</div>
							<!-- Password -->
							<div
								class="form-group"
								:class="{'warn': $v.form.password.$error, 'invalid' : this.errorMessage, shake: this.shake }"
                v-if="state===1 && hasPasswordLogin"
							>
								<i class="input-icon fa fa-lock"></i>
								<input
									v-model="$v.form.password.$model"
									id="password"
									data-testid="password"
									:type="passwordToggled? 'text': 'password'"
									class="form-control-lg form-control input"
									placeholder="Password"
								/>
								<!-- Validation Messages -->
								<span v-if="$v.form.password.$dirty">
									<small
										class="form-text text-warning small"
										v-if="!$v.form.password.required"
									>A password is required</small>
								</span>
							</div>
							<div class="forgot-pwd mb-2" v-if="errorMessage">
								<span class="text-danger">{{errorMessage}}</span>
							</div>
							<div class="forgot-pwd mb-2" v-if="accountLockedMessage">
								<span class="text-danger">
									{{accountLockedMessage}}
									<i class="fa fa-lock lock-font" aria-hidden="true"></i>
								</span>
							</div>
              <button v-if="state===0" class="btn btn-primary"  type="submit" data-testid="nextButton">Next</button>
							<button v-if="state===1 && hasPasswordLogin" class="btn btn-primary" type="submit" data-testid="submitBtn">Login</button>


              <b-dropdown class="ml-3" variant="primary" text="SSO Login" v-if="state === 1 && hasExternalSignIn">
                <b-dropdown-item href="#" v-for="loginOption in externalLoginOptions" :key="loginOption.id" @click="externalSignIn(loginOption)">
                  <i v-if="loginOption.loginMethod === loginMethodsConstant.Microsoft" class="fa-brands fa-windows"></i>
                  <i v-else-if="loginOption.loginMethod === loginMethodsConstant.Okta">
                    <object style="height:12px" data="/img/SSOLogos/okta.svg" type="image/svg+xml"></object></i>
                  Sign in with {{loginOption.name}}

                </b-dropdown-item>
              </b-dropdown>

							<button
                v-if="state===1 && hasPasswordLogin"
								class="btn btn-link"
								@click="forgotPassword"
								type="button"
								data-testid="forgotPasswordBtn"
							>Forgot Password</button>
					</div>


				</div>

			</div>
    </form>
	</div>
</template>
<script>

import axios from 'axios'
import { required, requiredIf } from 'vuelidate/lib/validators'
import loginMethods from '@/Constants/loginMethods'

export default {
	name: 'login',
	props: ['query'],
	data: function () {
		return {
			form: {
				userName: this.query.username,
				password: this.query.password
			},
			errorMessage: null,
			accountLockedMessage: this.query.lockedOutMessage,
			shake: false,
			passwordToggled: false,
      state:0, // 0 username entry, 1 password/extenal signin
      loginMethods: []
		}
	},
	watch: {
		'form.userName': function (_, oldVal) {
			if (oldVal === undefined) {
				this.$v.form.userName.$reset()
			}

      this.state = 0
      this.loginMethods = []
		},
		'form.password': function (_, oldVal) {
			if (oldVal === undefined) {
				this.$v.form.password.$reset()
			}
		}
	},
  computed:{
    hasPasswordLogin(){
        return this.loginMethods.some(lm => lm.loginMethod === loginMethods.Password)
    },
    hasExternalSignIn(){
      return this.loginMethods.some(lm => lm.loginMethod !== loginMethods.Password)
    },
    externalLoginOptions(){
      return this.loginMethods.filter(lm => lm.loginMethod !== loginMethods.Password)
    },
    loginMethodsConstant(){
      return loginMethods;
    }
  },
	methods: {
    async submitStage(){
      if(this.state===0) {
        await this.checkLoginMethods()
      }else if (this.state ===1){
        await this.submit()
      }
    },
		async submit () {
			this.$v.$touch()

			if (!this.$v.$invalid) {
				this.accountLockedMessage = ''
				this.errorMessage = ''
				var response = await axios.post('Account/Login', { Email: this.form.userName, Password: this.form.password, ReturnUrl: this.query.returnUrl }, { showload: true })

				if (response.data.errorMessage) {
					this.shakeInputs()
					this.errorMessage = response.data.errorMessage
				} else {
					this.errorMessage = null
					switch (response.data.response) {
						case 'Success':
							location.replace(`${process.env.VUE_APP_ROOT_API}${this.query.returnUrl}`)
							break
						case 'Verify':
							this.$router.replace({ name: 'VerifyCode', query: { returnUrl: this.query.returnUrl, selectedProvider: response.data.provider } })
							break
						case 'LockedOut':
							this.shakeInputs()
							this.accountLockedMessage = 'Account is Locked, Please try again later'
							break
						case 'LockedOutPerm':
							this.shakeInputs()
							this.accountLockedMessage = 'Account is Locked, due to inactivity. Please contact your system administrator'
							break
						case 'ChangePassword':
							this.$router.replace({ name: 'ChangePassword', query: { code: response.data.code, returnUrl: this.query.returnUrl, clientId: this.query.clientId }, params: { userId: response.data.userId, passwordComplexity: response.data.passwordComplexity, message: response.data.message } })
							break
						case 'Setup2FA':
							this.$router.replace({ name: 'Setup2FA', query: { returnUrl: this.query.returnUrl, selectedProvider: response.data.provider } })
							break
						case 'SetupSSO':
							this.$router.replace({ name: 'SetupSSO', query: { returnUrl: this.query.returnUrl } })
							break
					}
				}
			}
		},
    async checkLoginMethods () {
      try{
        const response = await axios.get('Account/LoginMethods', {
          showload: false,
          params: { username: this.form.userName }
        });

        this.loginMethods = response.data;

        if(this.loginMethods.length === 0){
          this.loginMethods = [{id:null, loginMethod: loginMethods.Password}]
        }

      }catch{
        this.loginMethods = [{id:null, loginMethod: loginMethods.Password}]
      }finally{
        this.state = 1
      }
    },
		externalSignIn ({id}) {
			window.location = `${process.env.VUE_APP_IDENTITY_API}ExternalSignIn?provider=${id}&returnUrl=${encodeURIComponent(this.query.returnUrl)}`
		},
		forgotPassword () {
			this.$router.push({ name: 'ForgotPassword', query: { returnUrl: this.query.returnUrl }, params: { username: this.form.username } })
		},
		shakeInputs () {
			this.shake = true
			setTimeout(() => {
				this.shake = false
			}, 500)
		}

	},
	created () {
		this.errorMessage = this.query.message

		if (this.query.username && this.query.password) {
			this.submit()
		}
	},
	validations () {
		return {
			form: {
				userName: { required },
				password: { required: requiredIf(this.hasPasswordLogin) }
			}
		}
	}
}
</script>
<style lang="scss" scoped>
@keyframes shake {
	0% {
		transform: translateX(0%);
	}
	15% {
		transform: translateX(-5%);
	}
	30% {
		transform: translateX(5%);
	}
	45% {
		transform: translateX(-3%);
	}
	60% {
		transform: translateX(1%);
	}
	75% {
		transform: translateX(-1%);
	}
	100% {
		transform: translateX(0%);
	}
}

.shake {
	animation-name: shake;
	animation-duration: 0.5s;
}

.fa {
	color: #666666;
}

.input-icon {
	position: absolute;
	top: 16px;
	left: 10px;
}

.form-group {
	position: relative;
}

.input {
	padding-left: 36px;
}

.pt-48 {
	padding-top: 48px;
}
</style>
